type AvWorkforceLogoProps = {
  width: number;
  height: number;
  alt?: string;
  responsive?: boolean;
  draggable?: boolean;
};

// Match the approved mobile ClipRect: retain the original AV artwork,
// exclude the Workforce wordmark, and fit inside the existing shell frame.
export default function AvWorkforceLogo({
  width,
  height,
  alt = 'AV Workforce',
  responsive = false,
  draggable
}: AvWorkforceLogoProps) {
  const visibleWidth = Math.min(width, (height * 0.875) / 0.522);
  const canvas = visibleWidth / 0.875;

  return (
    <span
      style={{
        display: responsive ? 'flex' : 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: responsive ? '100%' : width,
        height: responsive ? undefined : height
      }}
    >
      <span
        style={{
          display: 'block',
          position: 'relative',
          overflow: 'hidden',
          width: responsive ? '100%' : visibleWidth,
          height: responsive ? undefined : canvas * 0.522,
          aspectRatio: responsive ? '0.875 / 0.522' : undefined
        }}
      >
        <img
          src="/av-platform-icon-artwork.png"
          alt={alt}
          draggable={draggable}
          width={canvas}
          height={canvas}
          style={{
            position: 'absolute',
            top: responsive ? `${(-0.176 / 0.522) * 100}%` : -canvas * 0.176,
            left: responsive ? `${(-0.063 / 0.875) * 100}%` : -canvas * 0.063,
            width: responsive ? `${100 / 0.875}%` : canvas,
            height: responsive ? 'auto' : canvas,
            maxWidth: 'none'
          }}
        />
      </span>
    </span>
  );
}
